import React from 'react';

const propTypes = {};

const FilterContainer = ({ renderFields, renderButtons }) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='filter-container'>
      <div className='filter-container__fields'>{renderFields}</div>
      <div className='filter-container__buttons'>{renderButtons}</div>
    </div>
  );
};

FilterContainer.propTypes = propTypes;
export default FilterContainer;
